import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/scroll";
import { Nav } from "@/components/parallel/Nav";
import { Hero } from "@/components/parallel/Hero";
import { Marquee } from "@/components/parallel/Marquee";
import { WhatIs } from "@/components/parallel/WhatIs";
import { NotEnough } from "@/components/parallel/NotEnough";
import { Method } from "@/components/parallel/Method";
import { Production } from "@/components/parallel/Production";
import { RealWork } from "@/components/parallel/RealWork";
import { Workflow } from "@/components/parallel/Workflow";
import { Pricing } from "@/components/parallel/Pricing";
import { Experience } from "@/components/parallel/Experience";
import { StudentWork } from "@/components/parallel/StudentWork";
import { Career } from "@/components/parallel/Career";
import { WhoFor } from "@/components/parallel/WhoFor";
import { Philosophy } from "@/components/parallel/Philosophy";
import { FinalCTA } from "@/components/parallel/FinalCTA";
import { Contact } from "@/components/parallel/Contact";

const Home = () => (
  <main className="bg-obsidian text-cream font-body">
    <Nav />
    <Hero />
    <Marquee />
    <WhatIs />
    <NotEnough />
    <Method />
    <Production />
    <RealWork />
    <Workflow />
    <Pricing />
    <Experience />
    <StudentWork />
    <Career />
    <WhoFor />
    <Philosophy />
    <FinalCTA />
    <Contact />
  </main>
);

function App() {
  useEffect(() => initLenis(), []);

  return (
    <div className="App">
      <Seo
        title="PARA//EL — Creative Direction, Trained Like an Agency"
        siteName="PARA//EL"
        description="A creative education studio by Athrv Co. Learn filmmaking, content, brand and AI creative direction by shipping real client work. Agency Basic ₹35,000 · Advanced Creative/AI ₹1,50,000."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "PARA//EL",
          parentOrganization: "Athrv Co.",
          description: "Creative education and studio training for agency-grade filmmaking, content, brand and AI creative work.",
          email: "hello@parallel.studio",
        }}
      />
      <div className="bg-noise fixed inset-0 z-[60] pointer-events-none opacity-[0.05]" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
